var _a;
import { __decorate, __metadata, __param } from "tslib";
import { inject, injectable } from '@/inversify.config';
import { DetailServiceSymbol } from '@/services/DetailService';
import _ from 'lodash';
import { getSpaceDefaultFilterSortApi, getSpaceFilterSortApi, saveSpaceFilterSortApi } from '@cores/apis/workspace_api/workspace';
import { RefineService, RefineServiceSymbol } from '@/services/RefineService';
import { PageSelectorServiceSymbol } from '@/presentation/components/page-selector/PageSelectorService';
let AiTaggingCheckServiceImpl = class AiTaggingCheckServiceImpl {
    constructor(detailService, refineService, pageSelectorService) {
        this.detailService = detailService;
        this.refineService = refineService;
        this.pageSelectorService = pageSelectorService;
    }
    async enterCheckMode(params) {
        // 设置左侧过滤项字段
        let displayFilterList = [];
        try {
            displayFilterList = await getSpaceFilterSortApi({ space_id: this.detailService.spaceId, folder_id: this.detailService.folderId });
        }
        catch (e) {
            displayFilterList = await getSpaceDefaultFilterSortApi({ space_id: this.detailService.spaceId });
        }
        if (!_.includes(displayFilterList, 'WS_AI_FIELD')) {
            const folder_display_fields = ['WS_AI_FIELD', ...displayFilterList];
            saveSpaceFilterSortApi({
                space_id: this.detailService.spaceId,
                folder_id: this.detailService.folderId,
                filter_items: folder_display_fields,
            });
        }
        // 过滤当前字段
        let externalFieldsQueries = this.refineService.rankingConfs.externalFieldsQueries;
        const { field_name, field_id, field_label_scope } = params;
        const name = field_label_scope === 'SPACE' ? `${field_id}-${this.detailService.spaceId}` : field_id;
        const externalCustomFieldList = _.filter(externalFieldsQueries, { field: 'WS_AI_FIELD' });
        const hasRefine = externalCustomFieldList.some(item => item.value.some(valueItem => valueItem.name === name));
        if (!hasRefine) {
            const finallyEfq = {
                field: 'WS_AI_FIELD',
                type: 'refine',
                value: [{
                        alias: field_name,
                        name,
                    }],
            };
            // @ts-ignore
            externalFieldsQueries = externalFieldsQueries.concat(finallyEfq);
        }
        const efq = RefineService.externalFieldsQueries2EfqString(externalFieldsQueries);
        this.onFilterRefine(efq);
        // 刷新页面
        this.pageSelectorService.unselectAll();
    }
    onFilterRefine(efq) {
        this.detailService.isPatentsLoading = true;
        const filterData = {
            folderId: this.detailService.folderId,
            efq: '',
            q: _.cloneDeep(this.detailService.filterInfo.q),
            conditions: _.cloneDeep(this.detailService.filterInfo.conditions) || {},
        };
        filterData.efq = efq;
        filterData.conditions.efqString = efq;
        this.detailService.doFiltering(filterData);
    }
};
AiTaggingCheckServiceImpl = __decorate([
    injectable(),
    __param(0, inject(DetailServiceSymbol)),
    __param(1, inject(RefineServiceSymbol)),
    __param(2, inject(PageSelectorServiceSymbol)),
    __metadata("design:paramtypes", [Object, typeof (_a = typeof RefineService !== "undefined" && RefineService) === "function" ? _a : Object, Object])
], AiTaggingCheckServiceImpl);
export { AiTaggingCheckServiceImpl };
